import { ArtData } from "../../../types";
import { getAltText } from "../utils/art";
import { CornerActionType, ImagePreview } from "./ImagePreview";
import { Price } from "./Price";
type ArtConfig =
  | {
      href?: string;
      showPrice?: "above" | "below";
      text?: string | JSX.Element;
      onMouseEnter?: () => void;
      onMouseLeave?: () => void;
      actionBelow?: {
        actionComponent: JSX.Element;
      };
      actionCorner?: CornerActionType;
      tileClassName?: string;
      height?: number;
      hoverHeight?: number;
    }
  | undefined;
const ArtItem = ({
  art,
  artConfig,
  preload,
}: {
  art: ArtData;
  artConfig: ArtConfig;
  preload: boolean;
}) => {
  const height = artConfig?.height ?? 400;
  const hoverHeight = artConfig?.hoverHeight ?? artConfig?.height ?? 420;
  // height is set and no hover height, just don't hover. other wise, use default hover
  const Container = (props: JSX.IntrinsicElements["a"]) =>
    artConfig?.href ? (
      <>
        <a {...props} />
      </>
    ) : (
      <>
        <div {...(props as JSX.IntrinsicElements["div"])} />
      </>
    );
  return (
    <div
      key={art.slug}
      // Old wide card style
      // className="flex-[1_1_auto] lg:flex-[0.5_1_auto] duration-300"
      className="flex-[0_1_auto] lg:flex-[0_1_auto] duration-300 bg-accent/50 p-10 m-5"
      title={art.title}
      onClick={(e) => {
        if (!artConfig?.href) {
          e.stopPropagation();
          e.preventDefault();
        }
      }}
    >
      <div
        className={
          // Old wide card style
          // (artConfig?.tileClassName ??
          //   " bg-secondary/70 backdrop-blur-lg text-textSecondary rounded-2xl border-solid border-2 border-textPrimary shadow-md hover:shadow-lg") +
          // " pt-7 px-4 pb-4 duration-300 "
          (artConfig?.tileClassName ?? " text-textSecondary") + " duration-300 "
        }
      >
        {artConfig?.showPrice === "above" ? (
          <div className={art.orderSlug ? "line-through" : ""}>
            <Price item={art} />
          </div>
        ) : null}
        <Container
          href={artConfig?.href}
          className={
            "flex-1 items-center rounded-xl decoration-none flex justify-between flex flex-col" +
            (artConfig?.href ? " cursor-pointer " : " cursor-default ")
          }
          style={{
            textTransform: "capitalize",
            fontSize: "2rem",
          }}
        >
          <ImagePreview
            preload={preload}
            useImageSize="size-h500"
            {...artConfig?.actionCorner}
            transition={300}
            absolute
            onMouseEnter={artConfig?.onMouseEnter}
            onMouseLeave={artConfig?.onMouseLeave}
            alt={getAltText(art)}
            image={art.images?.[0]}
            size={{
              maxWidth: "80vw",
              height: height,
              top: 0,
              left:
                (height / hoverHeight -
                  (hoverHeight - height) / hoverHeight / 2) *
                  -100 +
                "%",
              transformX:
                (height / hoverHeight -
                  (hoverHeight - height) / hoverHeight / 2) *
                  100 +
                "%",
              transformY: 0,
              z: 1,
            }}
            hoverSize={{
              height: hoverHeight,
              z: 100,
              top: height - hoverHeight,
              left: "-100%",
              transformX:
                (height / hoverHeight -
                  (hoverHeight - height) / hoverHeight / 2) *
                  100 +
                "%",
              transformY: 0,
              // imagePath:
              //   art.images && art.images.length > 1
              //     ? art.images[1].path
              //     : undefined,
            }}
          />
          {/* <span style={{ flex: "0 0 auto" }}>{art.title}</span> */}
        </Container>
        {artConfig?.showPrice === "below" ||
        artConfig?.text ||
        artConfig?.actionBelow ? (
          <div className="pt-1 ">
            {artConfig?.text ? <div>{artConfig.text}</div> : null}

            {artConfig?.showPrice === "below" ? (
              <div
                className={"text-xs " + (art.orderSlug ? "line-through" : "")}
              >
                <Price item={art} />
              </div>
            ) : null}

            {artConfig?.actionBelow?.actionComponent ?? null}
          </div>
        ) : null}
      </div>
    </div>
  );
};

type ArtListItem<MType> = ArtData & { __meta?: MType };
export const ArtList = <MetaType,>({
  items,
  getArtConfig,
  preloadCount,
  justify = "justify-center",
  ...props
}: {
  items: ArtListItem<MetaType>[];
  noArt?: JSX.Element;
  getArtConfig?: (art: ArtData, __meta?: MetaType) => ArtConfig;
  preloadCount?: number;
  justify?: "justify-center" | "";
}) => (
  <div
    // Old wide card style
    // className="flex flex-wrap md:justify-center justify-between sm:mx-5 m-2 lg:mx-[5vw] 2xl:mx-[150px] gap-2"
    className={"flex flex-wrap " + justify}
  >
    {items?.length ? (
      items.map(({ __meta, ...art }, i) => (
        <ArtItem
          preload={i < (preloadCount ?? 0)}
          art={art}
          artConfig={getArtConfig?.(art, __meta)}
          key={art.slug}
        />
      ))
    ) : props.noArt ? (
      props.noArt
    ) : (
      <>NO ART</>
    )}
  </div>
);
